import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material/dialog";

@Component({
    selector: 'app-nome-grupo-dialog',
    templateUrl: './nome-grupo-dialog.component.html',
    styleUrls: ['./nome-grupo-dialog.component.scss'],
})
export class NomeGrupoDilaog {
    readonly dialogRef = inject(MatDialogRef<NomeGrupoDilaog>);
    readonly data = inject<string>(MAT_DIALOG_DATA);
    public nomeGrupo: string = '';

    public cancelar(): void {
        this.dialogRef.close();
    }

    public confirmar(): void {
        this.dialogRef.close(this.nomeGrupo);
    }
}